/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PecegepayBilletCoursefinpersonpaymentidOrder } from "../../clients/pecegePayBilletController/getApiV1PecegepayBilletCoursefinpersonpaymentidOrder.ts";

export const getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey = (
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams["courseFinPersonPaymentId"],
) =>
  [
    {
      url: "/api/v1/pecegepay/billet/:courseFinPersonPaymentId/order",
      params: { courseFinPersonPaymentId: courseFinPersonPaymentId },
    },
  ] as const;

export type GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey =
  ReturnType<
    typeof getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey
  >;

export function getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryOptions(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams["courseFinPersonPaymentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey(
    courseFinPersonPaymentId,
  );
  return queryOptions<
    GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500
    >,
    GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseFinPersonPaymentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PecegepayBilletCoursefinpersonpaymentidOrder(
        courseFinPersonPaymentId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os dados do pedido de boleto da parcela informada.
 * @summary Consultar pedido de boleto
 * {@link /api/v1/pecegepay/billet/:courseFinPersonPaymentId/order}
 */
export function useGetApiV1PecegepayBilletCoursefinpersonpaymentidOrder<
  TData = GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
  TQueryData =
    GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey,
>(
  courseFinPersonPaymentId: GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderPathParams["courseFinPersonPaymentId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404
          | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryKey(
      courseFinPersonPaymentId,
    );

  const query = useQuery(
    {
      ...getApiV1PecegepayBilletCoursefinpersonpaymentidOrderQueryOptions(
        courseFinPersonPaymentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder401
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder404
      | GetApiV1PecegepayBilletCoursefinpersonpaymentidOrder500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
